import isMobile from "../../plugins/is-mobile.js";
import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
// import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";

const scrollerArea = document.querySelector(".js-scroller");
const scrollerMain = document.querySelector(".js-scrollerMain");
const scrollerRight = document.querySelector(".grand-top-hero-right__inner");

if (scrollerArea) {
  if (!isMobile(768)) {
    // scrollerRight.style.minHeight = scrollerArea.clientHeight + "px";

    scrollerMain.style.width = 74.2 + "%";
    scrollerMain.style.height = window.innerHeight + "px";
  }

  var controller = new ScrollMagic.Controller();

  if (!isMobile(768)) {
    var mainTween = TweenMax.to(".js-scrollerMain", 1, {
      width: 50 + "%",
      ease: Linear.easeNone,
    });

    var main_scroller = new ScrollMagic.Scene({
      triggerElement: ".js-scroller",
      triggerHook: "onLeave",
      offset: 0,
      duration:
        document.querySelector(".js-scroller").clientHeight -
        window.innerHeight,
    })
      .setTween(mainTween)
      .setPin(".grand-top-hero-right__inner", { pushFollowers: false })
      // .addIndicators()
      .addTo(controller);
  }

  if (!isMobile(768)) {
    var textTween = TweenMax.to(".js-scrollerText", 3, {
      opacity: 0,
      transform: -5 + "%",
      force3D: true,
      ease: Linear.easeNone,
    });

    var text_scroller = new ScrollMagic.Scene({
      triggerElement: ".js-scroller",
      triggerHook: "onLeave",
      offset: 0,
      duration: 100,
    })
      .setTween(textTween)
      // .addIndicators()
      .addTo(controller);
  }

  if (!isMobile(768)) {
    var figureTween = TweenMax.to(".grand-top-hero figure", 1, {
      x: -10 + "%",
      force3D: true,
      ease: Linear.easeNone,
    });

    var figure_scroller = new ScrollMagic.Scene({
      triggerElement: ".js-scroller",
      triggerHook: "onLeave",
      offset: 0,
      duration:
        document.querySelector(".js-scroller").clientHeight -
        window.innerHeight,
    })
      .setTween(figureTween)
      // .addIndicators()
      .addTo(controller);
  }

  if (!isMobile(768)) {
    var imgTween = TweenMax.to(".grand-top-hero img", 1, {
      left: -10 + "%",
      ease: Linear.easeNone,
    });

    var img_scroller = new ScrollMagic.Scene({
      triggerElement: ".js-scroller",
      triggerHook: "onLeave",
      offset: 0,
      duration:
        document.querySelector(".js-scroller").clientHeight -
        window.innerHeight,
    })
      .setTween(imgTween)
      // .addIndicators()
      .addTo(controller);
  }

  var header_scroller = new ScrollMagic.Scene({
    triggerElement: ".grand-top-concept",
    triggerHook: "onLeave",
    offset: -80,
  })
    // .addIndicators()
    .addTo(controller);

  header_scroller.on("enter", () => {
    document.querySelector(".c-scrollPageTop").classList.add("is-show");
    document
      .querySelector(".l-grand-top-header")
      .classList.add("is-header-scrolled");
  });

  header_scroller.on("leave", () => {
    document.querySelector(".c-scrollPageTop").classList.remove("is-show");
    document
      .querySelector(".l-grand-top-header")
      .classList.remove("is-header-scrolled");
  });

  ///scroll
  var scrollTween = TweenMax.to(".js-hero-scroll", 3, {
    opacity: 0,
    transform: -10 + "%",
    force3D: true,
    ease: Linear.easeNone,
  });

  var scroll_scroller = new ScrollMagic.Scene({
    triggerElement: ".js-scroller",
    triggerHook: "onLeave",
    offset: 0,
    duration: 100,
  })
    .setTween(scrollTween)
    // .addIndicators()
    .addTo(controller);
}
